/**
 * Logging Service for AIconomics.net
 * Captures visitor information and reports it to the backend
 */

// Base API URL - update this with your production URL when deployed
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:8100/api';

class LoggingService {
  /**
   * Log a new visit to the site
   * @param {Object} additionalData - Any additional data to log (page info, etc.)
   */
  static async logVisit(additionalData = {}) {
    try {
      // Get current page
      const page = window.location.pathname;
      
      // Create payload
      const payload = {
        page,
        timestamp: new Date().toISOString(),
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        language: navigator.language || navigator.userLanguage,
        ...additionalData
      };

      // Send to backend
      await fetch(`${API_URL}/log-visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        // No need to wait for response
        keepalive: true
      });

    } catch (error) {
      console.error('Error logging visit:', error);
      // Don't throw - logging should never block the app
    }
  }

  /**
   * Log user interactions like slider changes, provider selections, etc.
   * @param {string} eventType - Type of interaction
   * @param {Object} eventData - Data associated with the interaction
   */
  static async logInteraction(eventType, eventData = {}) {
    try {
      const payload = {
        eventType,
        eventData,
        timestamp: new Date().toISOString(),
      };

      await fetch(`${API_URL}/log-interaction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        keepalive: true
      });
      
    } catch (error) {
      console.error('Error logging interaction:', error);
      // Don't throw - logging should never block the app
    }
  }

  /**
   * Log slider values when they're changed
   * @param {string} sliderName - Name of the slider
   * @param {number} value - New slider value
   */
  static logSliderChange(sliderName, value) {
    this.logInteraction('sliderChange', { sliderName, value });
  }

  /**
   * Log provider/model selection
   * @param {string} provider - Selected provider
   * @param {string} model - Selected model
   */
  static logProviderSelection(provider, model) {
    this.logInteraction('modelSelection', { provider, model });
  }
}

export default LoggingService;
